export default __webpack_public_path__ + "static/media/s.98be8663.jpg";